import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

export const resumeAnimation: any[] = [
  trigger('openCloseState', [
    state(
      'close',
      style({
        height: '0px',
        display: 'none',
        'padding-top': '0px',
        'padding-bottom': '0px',
        overflow: 'hidden'
      })
    ),
    state(
      'open',
      style({
        height: AUTO_STYLE,
        'padding-top': AUTO_STYLE,
        'padding-bottom': AUTO_STYLE,
        overflow: 'hidden'
      })
    ),
    transition('open <=> close', animate('300ms ease-in'))
  ]),
  trigger('dropdownMenuState', [
    state(
      'close',
      style({
        transform: 'rotateX(0deg)'
      })
    ),
    state(
      'open',
      style({
        transform: 'rotateX(180deg)'
      })
    ),
    transition('open <=> close', animate('300ms ease-in'))
  ]),
  trigger('chevronState', [
    state(
      'close',
      style({
        transform: 'rotate(-90deg)'
      })
    ),
    state(
      'open',
      style({
        transform: 'rotate(0deg)'
      })
    ),
    transition('open <=> close', animate('300ms ease-in'))
  ])
];
